const loggedInvalidRouteIdKeys = new Set<string>();

const logInvalidRouteId = (
    rawValue: string | undefined,
    decodedValue: string,
    reason: string
): void => {
    const path = window.location.pathname || '';
    const key = [path, reason, decodedValue].join('|');

    if (loggedInvalidRouteIdKeys.has(key)) {
        return;
    }

    loggedInvalidRouteIdKeys.add(key);
    const stack = new Error().stack?.split('\n').slice(2, 6).join('\n');

    console.warn('[RouteIdSanitizer] Dropped invalid route _id', {
        reason,
        rawValue,
        decodedValue,
        path,
        search: window.location.search,
        stack,
    });
};

export const sanitizeRouteId = (value?: string): string | undefined => {
    if (!value) {
        return undefined;
    }

    const decodedValue = (() => {
        try {
            return window.decodeURIComponent(value);
        } catch {
            logInvalidRouteId(value, value, 'decode-failed');
            return value;
        }
    })();

    const trimmedValue = decodedValue.trim();
    if (!trimmedValue) {
        logInvalidRouteId(value, decodedValue, 'blank-after-trim');
        return undefined;
    }

    const normalizedValue = trimmedValue.toLowerCase();
    if (normalizedValue === 'undefined' || normalizedValue === 'null') {
        logInvalidRouteId(value, decodedValue, 'literal-nullish-string');
        return undefined;
    }

    return trimmedValue;
};
